// extracted by mini-css-extract-plugin
export var arrow = "_8-8";
export var fadeIn = "_8-1";
export var header = "_8-4";
export var image = "_8-3";
export var link = "_8-7";
export var modal = "_8-2";
export var overlay = "_8-0";
export var subtitle = "_8-6";
export var title = "_8-5";